import { environment } from '../../../environments/environment';

export const apiUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const normalizedBaseUrl = environment.apiBaseUrl.endsWith('/')
    ? environment.apiBaseUrl.slice(0, -1)
    : environment.apiBaseUrl;

  return `${normalizedBaseUrl}${normalizedPath}`;
};
